import type { IEndpointProvider } from './IEndpointProvider';
import type TTConfig from '../cms/client/TTConfig';
import { BundledSettingsProvider } from './bundledSettingsProvider';
import type { AuthProvider } from '../auth/authProvider';

export class ApiEndpointProvider implements IEndpointProvider {

    public getEndpoint(): string {
        return BundledSettingsProvider.newInstance().getSettingSync<string>('publicApi/endpoint');
    }

    public getApiConfiguration(authProvider?: AuthProvider): TTConfig {
        return {
            endpoint: this.getEndpoint(),
            authProvider,
        };
    }
}
